module.exports = __webpack_public_path__ + "img/setting-icon.f539ba64.svg";